module.exports = __webpack_public_path__ + "img/gray_light_marker.f9e66924.svg";